module.exports = __webpack_public_path__ + "pc/img/logo.487a69ad.png";